import { Platform } from 'react-native';

/**
 * Hides Stripe SVG loading element/s that are direct children of body with height="0".
 * Otherwise, it can break the layout of the app if the SVG element is not hidden correctly.
 * Stripe team uses `height="0"` to hide the SVG loading element, but this is not enough
 * to completely hide it.
 */
export function hideStripeSvgLoadingElement() {
  if (Platform.OS !== 'web') return;

  const id = 'hide-stripe-svg-loader';
  const isAlreadyAdded = checkIfStyleExists(id);

  if (isAlreadyAdded) return;

  const style = document.createElement('style');

  style.id = id;
  style.textContent = `
    body > svg[height="0"] {
      display: none;
    }`;

  document.head.append(style);
}

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Checks if a style element with the specified ID exists in the document.
 * Helpful for avoiding duplicated actions, which can cause HMR to fail.
 */
function checkIfStyleExists(id: string) {
  if (Platform.OS !== 'web') return false;

  const maybeStyleElement = document.querySelector(`#${id}`);

  return maybeStyleElement !== null;
}
